/* Barra dell'applicazione, condivisa fra home e vista diagramma: marchio,
   utente, tema e uscita. Il tasto "indietro" non lo costruisce lei — lo
   inserisce l'editor nello slot `.app-bar-back`, perché prima di tornare alla
   home deve rilasciare il lock del diagramma. */
import { api, type User } from "../api.js";
import { el } from "../render/svg.js";
import { applyTheme, savedTheme } from "./theme.js";

export interface AppBarOptions {
  user: User;
  /** true nella home; nella vista diagramma no: lì la testata del diagramma è già sticky. */
  sticky?: boolean;
  /** predispone lo slot per il tasto "← Diagrammi" */
  withBackSlot?: boolean;
}

export function buildAppBar({ user, sticky = false, withBackSlot = false }: AppBarOptions): HTMLElement {
  const bar = el("div", "dash-head app-bar" + (sticky ? " app-bar-sticky" : ""));

  if (withBackSlot) bar.appendChild(el("span", "app-bar-back"));
  bar.appendChild(el("h1", "dash-title", "Fullsteps"));

  const actions = el("div", "dash-head-actions");
  actions.appendChild(el("span", "dash-user", `${user.name} · ${user.role}`));

  const themeBtn = el("button", "btn sm", "") as HTMLButtonElement;
  themeBtn.type = "button";
  const paintTheme = (): void => {
    const dark = savedTheme() === "dark";
    themeBtn.textContent = dark ? "☀ Chiaro" : "☾ Scuro";
    themeBtn.setAttribute("aria-pressed", String(!dark));
  };
  paintTheme();
  themeBtn.addEventListener("click", () => {
    applyTheme(savedTheme() === "dark" ? "light" : "dark");
    paintTheme();
    // la vista diagramma ridisegna con i propri colori: glielo diciamo
    document.dispatchEvent(new CustomEvent("fullsteps:theme"));
  });
  actions.appendChild(themeBtn);

  const logout = el("button", "btn sm", "Esci") as HTMLButtonElement;
  logout.type = "button";
  logout.addEventListener("click", async () => {
    await api.logout().catch(() => {});
    location.href = "/";
  });
  actions.appendChild(logout);

  bar.appendChild(actions);
  return bar;
}
